import Vue from "vue";
import "vue-tel-input/dist/vue-tel-input.css";
import vClickOutside from "v-click-outside";
import VueApexCharts from "vue-apexcharts";
import BootstrapVue from "bootstrap-vue";
import VueTelInput from "vue-tel-input";
import VCalendar from "v-calendar";
import "moment/locale/pt-br";
import wysiwyg from "vue-wysiwyg";
import LottieVuePlayer from "@lottiefiles/vue-lottie-player";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/icomoon/style.css";
import "./assets/scss/app.scss";
import "./components";

import "./plugins";
import "./components/designSystem";
import { init } from "./setup/api";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import lang from "element-ui/lib/locale/lang/pt-br";
import locale from "element-ui/lib/locale";

import ErrorHandlerMixin from "./mixins/error.js";

// configure language
locale.use(lang);

Vue.use(VueTelInput);
Vue.use(BootstrapVue);
Vue.use(vClickOutside);
Vue.use(VueApexCharts);
Vue.use(VCalendar);
Vue.use(CKEditor);
Vue.use(wysiwyg, {}); // config is optional. more below
Vue.use(LottieVuePlayer);

Vue.mixin(ErrorHandlerMixin);

init();

Vue.config.productionTip = false;

Vue.prototype.$DEV_ENV = process.env.NODE_ENV === "development";

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
